module.exports = __webpack_public_path__ + "img/9788984314658.1e45e3d8.jpg";